

<template>
   <div>
       <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2" style="height:64px">
                        <h5 class="modal-title">{{getSlugName(annotationData.asset)}}</h5>
                        <button type="button" @click="closeAnnotationWindow()" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <CancelIcon class="close-icon" style="height: 40px !important;width: 40px !important;color: #fff;"/>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                         <div class="asset-annotation-wrapper row" style="margin:0px !important;">
                              <div class="image-and-toolbar-wrapper col-md-8 p-0">
                                    <div class="asset-annotation-editor" :class="!isEnabled('manage-asset-annotaion') ? 'annotation-editor-full-height':''">
                                        <div v-if="!isImageEditorLoaded" style="position: absolute; inset-inline-start :50%; top: 50%; transform: translate(-50%, -50%);">
                                             {{$t('Loading')}} ...
                                         </div>
                                         <tui-image-editor v-show="isImageEditorLoaded"  class="fusion-tui-image-editor-main-wrapper" style="border-inline-end: 1px solid #333;" @hook:mounted="addUndoNdDeleteBtn();relocateToolsBars()" :include-ui="useDefaultUI" ref="tuiImageEditor" :options="options"></tui-image-editor>
                                    </div>
                                    <div class="annotation-messages-wrapper" v-if="isEnabled('manage-asset-annotaion')">
                                        <chatTextArea :isFileAttachmentRequired="false"  :customStylesTextarea="{'placeholderName':'Add annotation comment...','disabledActions':['attach-tasks'],'displayOnlyAttachedFileName':true}" @messageText="postAnnotationData()" ref="annotationCommentRef" style="width:100%;"></chatTextArea>
                                    </div>
                              </div>
                              <div class="asset-annotation-comment-wrapper col-md-4 p-0 h-100" v-on:scroll="loadMoreAnnotationComments($event)">
                                   <div v-if="!commentsList.length" style="text-align: center; color: rgb(147 146 146); font-size: 18px; position: relative; top: 108px;">
                                       {{$t('No comments yet')}}.
                                   </div>
                                   <CommentsThread @updateCommentStatus="selectedAnnotationMessage = null" @click.native="handleAnnotationEdit(comment)" :class="selectedAnnotationMessage && comment._id == selectedAnnotationMessage._id ? 'scroll-highlight-class' : ''" @deleteRepliedComment="handleAnnotationMessageDelete" @editCommentText="handleAnnotationEditMessage" v-for="comment in commentsList" @openPictureInPicture="handleShowAnnotationPreview" :isRepliedRequired="false" :key="comment.asset_id" :commentData="comment" :repliedCommentslist="[]" :reviewInfo="{}"></CommentsThread>
                              </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
        <imagePreviewDialog v-cloak ref="imagePreviewDialogRef" @hook:mounted="handleImageMounted" v-if="isPreviewOpened" :selectedFile="previewData" @closeMiniPlayer="isPreviewOpened = false"></imagePreviewDialog>
   </div>
</template>

<script>
import CancelIcon from "../core/InlineCancelField.vue";
import 'tui-color-picker/dist/tui-color-picker.css';
import 'tui-image-editor/dist/tui-image-editor.css';
import { ImageEditor } from '@toast-ui/vue-image-editor';
import Utils from '../../components.utils.js';
import {mapActions , mapMutations , mapGetters} from 'vuex';
import moment from 'moment';
import chatTextArea from '../core/ChatTextarea.vue';
import CommentsThread from '../core/CommentsThread.vue';
import imagePreviewDialog from "../core/ImagePreviewDialog.vue";
import {NotifierConstants} from '../../components.constants.js';
export default {
   name: 'annotation-image-editor-comments',
   props:['isBase64dataRequired','isChatUpload','menuPosition'],
   components:{
       CancelIcon,
       'tui-image-editor': ImageEditor,
       chatTextArea,
       CommentsThread,
       imagePreviewDialog
   },
   data(){
       return {
            commentsList: [], //{ "_id": "65c215a7bc129141c1da9780", "asset_id": "65bc7800fc796d106ebe261a", "created_by_id": "65bc7800fc796d106ebe261a", "annotaion_thumbnail_url":"share://TO_NEW_PROXY/Annotations/d22889e6-4fdb-11ef-96cb-f889d2b8e46f.png", "attachments": [], "username" : "Syeda", "profile_image": "https://workflowlabs.app/proxy/UsersProfileImages/b50dd258-cc34-11ec-9714-0a0092731bf6.png", "attachments_info":[], "status": "new", "comment": "This is a sample comment", "created_datetime": "2024-02-06T16:49:03.867473", "modified_datetime": "2024-02-06T16:49:03.867473"},
            useDefaultUI: true, 
            options: {
               includeUI:{
                uiSize: {
                    width: null,
                    height: null
                },
                imageSize:{
                   width:null,
                   height:null
                },
                  loadImage: {
                          path: this.getProxyPath(this.$route.params.annotationData.asset),
                          name: 'My image',
                  }, 
                  menu: ['shape','icon', 'text', 'draw'],
                  initMenu: 'draw',
                  menuBarPosition: "left",
               }
            },
           uploadedProxyThumbnailPath:'',
           annotationData:null,
           routeParentInfo:null,
           isImageEditorLoaded:false,
           editorLoadingGif : Utils.getUploadingGif(),
           previewData:null,
           isPreviewOpened:false,
           selectedAnnotationMessage: null,
           pageInfo:{},
       } 
   },
   methods:{
      getSlugName(file){
           if(file && Object.prototype.hasOwnProperty.call(file,'slug_name')){
               return file.slug_name;
           }
           if(file && Object.prototype.hasOwnProperty.call(file,'file_name')){
               return file.file_name;
           }
          return '';
      },
      getProxyPath(fileInfo){
         if(fileInfo && Object.prototype.hasOwnProperty.call(fileInfo,'proxy_info') && Object.prototype.hasOwnProperty.call(fileInfo.proxy_info,'thumbnail_uri')){
            return Utils.convertToLoginIPDomainName(fileInfo.proxy_info.thumbnail_uri);
         }
         return Utils.getNoThumbnailImg();
      },
      loadMoreAnnotationComments(e){
          if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
             if(this.pageInfo.page < this.pageInfo.page_count){
                let payload = {params:{asset_id:this.annotationData.asset.asset_id,comment_type:'annotate',version_id:this.annotationData.asset.version_id,page:this.pageInfo.page + 1}};
                this.getAssetsAnnotationWithComments(payload).then(data =>{
                    this.commentsList = this.commentsList.concat(data.asset_comments);
                    this.pageInfo.asset_comments_per_page = data.asset_comments_per_page;
                    this.pageInfo.page = data.page;
                    this.pageInfo.page_count = data.page_count;
                    this.pageInfo.total_asset_comments = data.total_asset_comments;
                });
             }
           }
      },
      isEnabled(priv) {
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), priv);
      },
      handleAnnotationEdit(commentData){
          console.log(`[handleAnnotationEdit]`,commentData.annotaion_thumbnail_url);
          this.$refs.tuiImageEditor.invoke('loadImageFromURL',commentData.annotaion_thumbnail_url);
          this.selectedAnnotationMessage = commentData;
      },
      handleAnnotationMessageDelete(messageData){
          let c = window.confirm('Are you sure you want to delete the Comment ?');
          if(c){
              let payload = {commentId:messageData._id,status:'deleted'};
              this.updateAssetsAnnotationWithComments(payload).then((data)=>{
                  if(!Utils.isAcceptedStatusCode(data.statusCode)) {
                      this.$toast.error(data.message);
                  }else{
                   // this.commentsList = this.commentsList.filter(el => el._id != messageData._id);
                      let foundIndex = this.commentsList.findIndex((el)=>{
                            return el._id == messageData._id;
                      });
                      if(foundIndex > -1){
                          this.commentsList[foundIndex].status = 'deleted';
                      }
                  }
              });
          }
      },
      handleAnnotationEditMessage(message,messageData){
          let payload = {commentId:messageData._id,comment:message,status:'edited',edited:true};
          this.updateAssetsAnnotationWithComments(payload).then((data)=>{
              console.log(`[updateAssetsAnnotationWithComments]`,data);
              if(!Utils.isAcceptedStatusCode(data.statusCode)) {
                  this.$toast.error(data.message);
              }else{
                  let foundIndex = this.commentsList.findIndex((el)=>{
                        return el._id == messageData._id;
                  });

                  if(foundIndex > -1){
                      if(data.modified_data){
                        let m = Object.assign(this.commentsList[foundIndex],data.modified_data);
                        this.commentsList[foundIndex] = m;
                      }
                  }
              }
          });
      },
      handleImageMounted(){
     /*     setTimeout(()=>{
             this.$refs.imagePreviewDialogRef.$el.display = 'block';
         },500); */
      },
      handleAnnotationCommentModified(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
          console.log(`[handleAnnotationCommentModified]`,notification);
          if(notification && notification.message){
            let foundIndex = this.commentsList.findIndex((el)=>{
                  return el._id == notification.message._id;
            });
            if(foundIndex > -1){
              this.$set(this.commentsList,foundIndex,notification.message)
            }
          }
      },
      handleAnnotationCommentCreated(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
          if(notification.message && notification.message.comment_type == 'annotate'){
                let foundIndex = this.commentsList.findIndex((el)=>{
                      return el._id == notification.message._id;
                });
                if(foundIndex == -1)
                    this.commentsList.unshift(notification.message);
          }
      },
      handleShowAnnotationPreview(comment){
            let slugName = '', commentData = {};
            if(this.annotationData.asset.slug_name){
                slugName = this.annotationData.asset.slug_name;
            }else{
               slugName = this.annotationData.asset.file_name;
            }
            Object.assign(commentData,{file_name:slugName,mime_type:'image/png',proxy_info:{"thumbnail_uri":comment.annotaion_thumbnail_url}});

            this.previewData = commentData;
            this.$nextTick(()=>{
               this.isPreviewOpened = true;
            });
      },
      postAnnotationData(){
          let payload = {};
          if(this.annotationData.asset.asset_id){
             payload.asset_id = this.annotationData.asset.asset_id;
          }else{
             payload.asset_id = this.annotationData.asset._id;
          }
          payload['version_id'] = this.annotationData.asset.version_id;
          if(this.$refs.tuiImageEditor.invoke('isEmptyUndoStack')){
              alert("Empty annotation");
              return;
          }

          if(!this.$refs.tuiImageEditor.invoke('isEmptyUndoStack')){
             payload.annotaion_thumbnail_url = this.$refs.tuiImageEditor.invoke('toDataURL');
          }

          if(this.$refs.annotationCommentRef && this.$refs.annotationCommentRef.commentText){
              payload.comment = this.$refs.annotationCommentRef.commentText;
          }
          if(!payload.comment){
              alert("Empty comment.");
              return;
          }
          payload.status = "new";
          payload.comment_type = "annotate";
          this.addAssetsAnnotationWithComments(payload).then(async(data)=>{
                console.log("posted......",data);
              if(!Utils.isAcceptedStatusCode(data.statusCode)) {
                  this.$toast.error(data.message);
              }else{
                  await this.$refs.tuiImageEditor.invoke('clearObjects');
                  this.$refs.tuiImageEditor.invoke('clearUndoStack');
                  this.$refs.tuiImageEditor.invoke('clearRedoStack');
              }
          });
      },
      relocateToolsBars(){
          //this.isEditorToolsWrapperVisible = true;
      /*     let partitionLi = document.createElement('li');
          partitionLi.classList.add('tui-image-editor-item');
          partitionLi.classList.add('custom-added');
          partitionLi.innerHTML = `<div class="tui-image-editor-icpartition"></div>`;
          parent.document.querySelector('.tui-image-editor-menu').appendChild(partitionLi); */

          this.relocateElementBySelector('.tie-btn-delete.tui-image-editor-item.help','.tui-image-editor-menu');
          this.relocateElementBySelector('.tie-btn-redo.tui-image-editor-item.help','.tui-image-editor-menu');
          this.relocateElementBySelector('.tie-btn-undo.tui-image-editor-item.help','.tui-image-editor-menu')


          let buttonElement = document.createElement('div'); 
          // buttonElement.classList.add('tui-image-editor-item');
          buttonElement.classList.add('custom-actions-button-wrapper');

          let ulElement = document.createElement('div');
          ulElement.classList.add('custom-annotation-button-wrapper');

/* 
          if(!this.isImageAnnotation){
              let applyButtonLi = document.createElement('div');
              applyButtonLi.innerHTML = '<button type="button" title="Cancel Annotation (c)" class="btn btn-outline-secondary annotation-cancel-btn">Cancel</button>';
              applyButtonLi.onclick = () => {
                this.cancelAnnotation();
              };
              ulElement.appendChild(applyButtonLi);
          }

          let cancelButtonLi = document.createElement('div');
          cancelButtonLi.innerHTML = '<button type="button" title="Apply Annotation (s)" class="btn btn-primary apply-annotation-btn">Apply</button>';
          cancelButtonLi.onclick = () => {
            this.applyAnnotation();
          };

          ulElement.appendChild(cancelButtonLi);
          buttonElement.appendChild(ulElement);


          let applyCancelPanelEl = parent.document.getElementById('apply_cancel_annotation_panel');
          if(applyCancelPanelEl) applyCancelPanelEl.remove();

          if(this.isAnnotationEditorVisible){
            let applyCancelActionPanel = document.createElement('div');
            applyCancelActionPanel.id = 'apply_cancel_annotation_panel';
            parent.document.querySelector('.fusion-tui-image-editor-main-wrapper').insertAdjacentElement('afterend', applyCancelActionPanel);
            parent.document.querySelector('#apply_cancel_annotation_panel').appendChild(buttonElement);
          } */
        },
        getUploadedProxyThumbnailPath(){
          return  this.uploadedProxyThumbnailPath;
        },
        getFilenameWithTimestamp: function(){ 
            let file_name = this.annotationData.asset.file_name;
            let lastIndexOfDot = file_name.lastIndexOf('.');
            let namePart = file_name.slice(0,lastIndexOfDot);
            return namePart +'_'+ moment().format('DDMMYY')+"_"+ moment().format('HHmmss') + '.png';
        },
        relocateElementBySelector(elementSelector, destSelector) {
          let element = document.querySelector(elementSelector);
          let elementParent = element.parentElement;
          let destElement = document.querySelector(destSelector);
          elementParent.removeChild(element);
          destElement.prepend(element);
      },

      addUndoNdDeleteBtn(){
         let partitionLi = document.createElement('li');
         partitionLi.classList.add('tui-image-editor-item');
         partitionLi.classList.add('custom-added');
         partitionLi.innerHTML = `<div class="tui-image-editor-icpartition"></div>`;
         document.querySelector('.tui-image-editor-menu').prepend(partitionLi);
         this.relocateElementBySelector('.tie-btn-delete.tui-image-editor-item.help','.tui-image-editor-menu');
         this.relocateElementBySelector('.tie-btn-redo.tui-image-editor-item.help','.tui-image-editor-menu');
         this.relocateElementBySelector('.tie-btn-undo.tui-image-editor-item.help','.tui-image-editor-menu')
      },
      handleAnnotationEditorKeyBoard(event){
          let keyCode = event.keyCode || event.which;

          if(event.ctrlKey && event.key === 'z') {
              event.preventDefault();
          }

          if(keyCode == 27){ // ESC key
              // this.$emit('closeAnnotationEditor');
              this.closeAnnotationWindow();
              return true;
          }
     },
     executeClose(){
        if(Object.keys(this.routeParentInfo).length!=0 && Object.keys(this.routeParentInfo).includes("name") ){
            this.$router.replace({
              name: this.routeParentInfo.name,
              params:this.routeParentInfo.params,
              query:Object.assign({}, this.routeParentInfo.query?this.routeParentInfo.query:{}),
            })
          }else{
            this.$router.replace({
              name: "explorer",
            })
          }
     },
     closeAnnotationWindow(){
         if(this.$refs.tuiImageEditor.invoke('isEmptyUndoStack')){
              this.executeClose()
         }else{
            let c = window.confirm('You have unsaved annotation. Are you sure to close.');
            if(c){
                this.executeClose();
            }
         }
     },
     ...mapActions('upload',['getProxyBinUploadDetails']),
     ...mapActions('review',['updateCommentData']),
     ...mapActions('assets',["addAssetsAnnotationWithComments","getAssetsAnnotationWithComments","updateAssetsAnnotationWithComments"]),
     ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
     ...mapGetters("users",["getLoggedInUserPrivilege"]),
   },
   mounted(){
       console.log(`this.$refs.tuiImageEditor`,this.$refs.tuiImageEditor);
        window.addEventListener('keydown', this.handleAnnotationEditorKeyBoard);
        this.$nextTick(()=>{
            this.isImageEditorLoaded = true;
        });
        this.$refs.tuiImageEditor.editorInstance.on("ready",()=>{
            //alert("alllllllllll");
            console.log("ready............");
        });
   },

   created(){
      this.annotationData = this.$route.params.annotationData;
      this.routeParentInfo = this.$route.params.parentinfo;
      let payload = {params:{asset_id:this.annotationData.asset.asset_id,comment_type:'annotate',version_id:this.annotationData.asset.version_id}};
      if(this.annotationData.asset.asset_id){
            payload.asset_id = this.annotationData.asset.asset_id;
         }else{
            payload.asset_id = this.annotationData.asset._id;
        }
      this.getAssetsAnnotationWithComments(payload).then(data =>{
           console.log("Get data [getAssetsAnnotationWithComments]",data);
           this.commentsList = data.asset_comments;
           this.pageInfo.asset_comments_per_page = data.asset_comments_per_page;
           this.pageInfo.page = data.page;
           this.pageInfo.page_count = data.page_count;
           this.pageInfo.total_asset_comments = data.total_asset_comments;
      });
      this.addWSEventListener({eventname:NotifierConstants.assetCommentCreated, callback:this.handleAnnotationCommentCreated,parent:"annotation-image-editor-comments"});
      this.addWSEventListener({eventname:NotifierConstants.assetCommentModified, callback:this.handleAnnotationCommentModified,parent:"annotation-image-editor-comments"});  
   },

  beforeDestroy(){
      window.removeEventListener('keydown', this.handleAnnotationEditorKeyBoard);
      this.removeWSEventListener({eventname:NotifierConstants.assetCommentCreated, callback:this.handleAnnotationCommentCreated,parent:"annotation-image-editor-comments"});
      this.removeWSEventListener({eventname:NotifierConstants.assetCommentModified, callback:this.handleAnnotationCommentModified,parent:"annotation-image-editor-comments"});  
   }
}
</script>

<style lang="scss" scoped>
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
$action-bottom-panel-color: #1d2022;
$scrollbar-thumb-background:#333;

::v-deep{
   .tui-image-editor-header { display: none !important; }
   .tui-image-editor-container .tui-image-editor-main { top: 0; }
   .tui-image-editor-help-menu.top{display: none !important;}
   .tui-image-editor-virtual-range-pointer{
     background: #fff !important;
   }
   .tie-icon-add-button [data-icontype="icon-star"], [data-icontype="icon-star-2"]{
      display: none !important;
   }
   .tui-image-editor-menu-icon .tui-image-editor-partition, .tui-image-editor-menu-icon .tie-icon-add-button:not(:first-child){
      display: none !important;
   }
   .annotation-apply-button{
      display: inline-block;
      float: inline-end;
      position: relative;
      inset-inline-end: 16px;
      top: 7px;
   }

   .tui-image-editor-item.custom-added{
      top: 9px !important;
    }

    html{
      overflow-y:auto !important;
    }

    .tui-image-editor-submenu{
        visibility: hidden;
        transition: transform 0.6s cubic-bezier(0.83, 0, 0.17, 1);
    }

    .tui-image-editor-controls:hover + .tui-image-editor-main-container  .tui-image-editor-submenu{
        visibility: visible !important;  
    } 

    .tui-image-editor-submenu:hover {
        visibility: visible !important;
    }

    .common-input-field{
      border: none !important;
    }

    .tui-image-editor-menu{
        display: flex;
        flex-direction: column-reverse;
    }

    #apply_cancel_annotation_panel{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: $action-bottom-panel-color;
      height: 45px;
      padding-inline-end: 0.39rem !important;
   }

   .tui-image-editor-help-menu.right{
      display: none !important;
   }

   .tui-image-editor-align-wrap .tui-image-editor{
      inset-inline-start: 0 !important;
   }

   .tui-image-editor-main-container{
      background: $primary-background !important;
   }

  .tui-image-editor-wrap::-webkit-scrollbar {
    width: 3px;
    height:4px;
  }

  .tui-image-editor-wrap::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  .tui-image-editor-wrap::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  .tui-image-editor-wrap::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }
}

html{
  overflow-y:auto !important;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      padding: 0px 0px 0px 0px;
      width:100%;
      position:relative;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
  z-index: 9999999;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-title{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal-header .close {
    // margin: -1rem -19px -0rem auto !important;
    margin:0px !important;
    padding: 0px !important;
}

.modal-footer{
    justify-content: start;
    position: fixed;
    inset-inline-start: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    z-index:9;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.asset-annotation-editor{
  height: calc(74.3vh - 46px) !important;
  position: relative;
}

.annotation-messages-wrapper{
    display: flex;
    justify-content: center;
    height: calc(40% - 81px);
    background: #1a1e21;
    border: 1px solid #333;
    padding: 0px 10px 0px 10px;
}

.asset-annotation-comment-wrapper {
  height: calc(100vh - 64px) !important;
  overflow-y: auto;
}

.common-input-field{
  border: none !important;
}

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover !important;
  }

  .scroll-highlight-class{
     border: 2px solid #007bff !important;
  }

  .annotation-editor-full-height{
     height: 100% !important;
  }
</style>